import axios from 'axios';
import { PowerBIExportFormat } from 'views/power-bi-reports/types/power-bi-export-format.enum';
import { PowerBIExportStatus } from 'views/power-bi-reports/types/power-bi-export-status.type';
import { CreatePowerBIExportInput } from 'views/power-bi-reports/types/create-power-bi-export-input.type';

// POST
// /ewosapi/v1/powerbi/company/{globalCompanyId}/reports/{powerBIReportId}/export/{format}
export const postPowerBIReportExport = async (
  globalCompanyId: string,
  powerBIReportId: string,
  format: PowerBIExportFormat,
  request: CreatePowerBIExportInput
): Promise<PowerBIExportStatus> => {
  const res = await axios.post<PowerBIExportStatus>(
    `/ewosapi/v1/powerbi/company/${globalCompanyId}/reports/${powerBIReportId}/export/${format}`,
    request
  );
  return res.data;
};

// GET
// /ewosapi/v1/powerbi/company/{globalCompanyId}/reports/{powerBIReportId}/export/{exportId}
// checks the status of a Power BI export
export const getPowerBIReportExportStatus = async (
  globalCompanyId: string,
  powerBIReportId: string,
  exportId: string
): Promise<PowerBIExportStatus> => {
  const res = await axios.get<PowerBIExportStatus>(
    `/ewosapi/v1/powerbi/company/${globalCompanyId}/reports/${powerBIReportId}/export/${exportId}`
  );
  return res.data;
};
